import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { AlertTriangle } from "lucide-react";

import { createAxiosInstance } from "api/axiosConfig";
import { PATIENT_DOCUMENTS_CONTROLER_URL } from "api/Service";
import { Button } from "components/ui/Button";

import styles from "./DeleteConfirmModal.module.css";

export const DeleteConfirmModal = ({
  isOpen,
  onClose,
  document,
  onSuccess,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const tenant =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  const handleDelete = async () => {
    if (!document?.id) {
      toast.error("Invalid document");
      return;
    }

    setIsDeleting(true);
    try {
      const axiosInstance = createAxiosInstance();
      await axiosInstance.delete(
        `${tenant}${PATIENT_DOCUMENTS_CONTROLER_URL}/delete`,
        { data: { id: document.id } }
      );
      toast.success("Document deleted successfully");
      onSuccess?.();
      onClose();
    } catch (error) {
      console.error("Error deleting document:", error);
      toast.error("Failed to delete document");
    } finally {
      setIsDeleting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            disabled={isDeleting}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L13 13M1 13L13 1"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>

        <div className={styles.content}>
          <div className={styles.iconWrapper}>
            <AlertTriangle />
          </div>

          <h5 className={styles.message}>
            Are you sure you want to delete this document?
          </h5>
        </div>

        <div className={styles.footer}>
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleDelete} disabled={isDeleting}>
            {isDeleting ? "Deleting..." : "Yes"}
          </Button>
        </div>
      </div>
    </div>
  );
};
